import { render, staticRenderFns } from "./InvestmentStep.vue?vue&type=template&id=8e46914e&scoped=true"
import script from "./InvestmentStep.vue?vue&type=script&lang=ts&setup=true"
export * from "./InvestmentStep.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./InvestmentStep.vue?vue&type=style&index=0&id=8e46914e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e46914e",
  null
  
)

export default component.exports